import { useEffect, useEffectEvent, useState } from 'react';

import * as EventEmitter from '@/utils/event-emitter';

const useIsModalOpen = (id: string): boolean => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onModalStatusChange = useEffectEvent((isOpen: boolean) => {
    setIsModalOpen(isOpen);
  });

  useEffect(() => {
    const openModalId = `${id}::open`;
    EventEmitter.on(openModalId, (data) => {
      onModalStatusChange(!!data);
    });

    return () => EventEmitter.off(openModalId);
  }, [id]);

  return isModalOpen;
};

export default useIsModalOpen;
